const FOCUSABLE_ELEMENTS_SELECTOR = 'input, select, textarea';

export { FOCUSABLE_ELEMENTS_SELECTOR };
